export function getRemValue(valueInPx: number) {
    return `${valueInPx / 16}rem`;
}
